module.exports = __webpack_public_path__ + "static/assets/472919f5c7efbbca30b12c82c8ffe491.png";